import EventHandlers from './EventHandlers.js';

/**
 * Events — the event registry.
 *
 * all() returns the handler map that data() exposes as `this.evt`, so the
 * template binds events declaratively:
 *
 *   <button @click="evt.bookClick">
 *
 * Each entry delegates to the same-named implementation in EventHandlers,
 * passing (event, component). Add a new button = add one line here + one
 * implementation there.
 */

var Events = new Object();

/**
 * Create one delegating handler bound to the Alpine component.
 *
 * NOTE: plain function (not arrow) so Alpine binds `this` to the component
 * instance at call time.
 *
 * @param  {string} name  Handler name in EventHandlers
 * @return {function}
 */
Events.createEventHandler = function (name) {

  return function (event) {

    return EventHandlers[name](event, this);

  };

};

/**
 * The full registry — one entry per template-bound event.
 *
 * @return {object}
 */
Events.all = function () {

  var _this = this;

  return {

    bookClick: _this.createEventHandler('bookClick'),
    bookFrameLoad: _this.createEventHandler('bookFrameLoad'),
    bookModalClose: _this.createEventHandler('bookModalClose'),
    bookResizeToggle: _this.createEventHandler('bookResizeToggle'),
    chatClick: _this.createEventHandler('chatClick'),
    callClick: _this.createEventHandler('callClick'),
    supportClick: _this.createEventHandler('supportClick'),
    oneMindClick: _this.createEventHandler('oneMindClick'),
    oneMindPanelClose: _this.createEventHandler('oneMindPanelClose'),
    oneMindResizeToggle: _this.createEventHandler('oneMindResizeToggle'),
    callModalClose: _this.createEventHandler('callModalClose'),
    phoneCopyClick: _this.createEventHandler('phoneCopyClick'),
    escapeClose: _this.createEventHandler('escapeClose'),
    collapseToggle: _this.createEventHandler('collapseToggle'),

  };

};

export default Events;
